import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';

/**
 * PGSS-5121: per-order VAS warning indicator. Renders a single amber icon when a VAS order's production
 * is not finished yet (`is_vas && !production_completed`) — nothing otherwise. One shared component so the
 * create-shipment order picker and the packing Check List flag the same thing the same way (theme 2:
 * per-order, not a shipment-wide banner). `production_completed` comes from the backend's `vas-completed`
 * event (reliable after the read fix, PGSS-5121 #3950).
 *
 * Callers gate the *context* (e.g. only the staff create-shipment picker); this component only decides
 * whether the order itself is incomplete.
 */
export default function VasWarningIcon({ vasStatus, className = '', title }) {
  if (!vasStatus?.is_vas || vasStatus?.production_completed) {
    return null;
  }
  const tip =
    title || 'VAS work is not complete for this order — finish the sandblasting / etching before it ships.';
  return (
    <Tooltip title={tip}>
      <Icon className={`text-18 align-middle ${className}`} sx={{ color: 'warning.main' }}>
        warning_amber
      </Icon>
    </Tooltip>
  );
}
